var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14202",
    "data-name": "Group 14202",
    transform: "translate(-630 -77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize",
    transform: "translate(631 78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13151",
    "data-name": "Path 13151",
    d: "M27.857,3v.857H30.68L27,7.535l.606.608,3.68-3.68V7.286h.857V3Z",
    transform: "translate(-17.143)",
    fill: "#9ca4ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13152",
    "data-name": "Path 13152",
    d: "M8.143,27.607,7.539,27,3.857,30.68V27.857H3v4.286H7.286v-.857H4.463Z",
    transform: "translate(0 -17.143)",
    fill: "#9ca4ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3242",
    "data-name": "Rectangle 3242",
    transform: "translate(630 77)",
    fill: "none",
    stroke: "#9ca4ba",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.cb71cc0341bd6a1509097f5ee3056049.svg";
export { ForwardRef as ReactComponent };